/** The server raises `entitlement_limit_reached:alerts.watchlists` (or older `entitlement_quota_exceeded`/`entitlement_required`) when a plan's watch allowance is used up. */
export const WATCH_LIMIT_EVENT = 'cfx:watch-limit';

const LIMIT_CODES = ['entitlement_limit_reached', 'entitlement_quota_exceeded', 'entitlement_required'];

export function isWatchLimitError(error: unknown): boolean {
  const msg = String((error as { message?: string })?.message ?? error ?? '');
  return LIMIT_CODES.some((code) => msg.includes(`${code}:alerts.watchlists`));
}

export function announceWatchLimit(kind: 'watch' | 'search') {
  window.dispatchEvent(new CustomEvent(WATCH_LIMIT_EVENT, { detail: { kind } }));
}
